class ResidentPortalFilter{

    filterCollectionByUserType(collection = [], userType = ""){
        // Items in List must have is_cso or is_res
        userType = userType.toLowerCase();      
        collection = collection.filter(listItem=>{
            switch (userType){
                case "cso" :
                    return listItem.is_cso == 1
                    break;
                case "res" :
                    return listItem.is_res == 1
                    break;
                case "resident" :
                    return listItem.is_res == 1
                    break;
                default :
                    return true;
            }
        })
        return collection;
    }
}

module.exports = ResidentPortalFilter;